import '@autocx/websites/polyfills';

import Website from "@autocx/websites";

/**
 * Webpack: Entry point to build the React application.
 */

export default function App(props) {
    return (
        <Website
            {...props.context}
            policies={props.website.policies}
            currency={props.website.workspaceCurrency}
            country={props.website.workspaceCountry}
            header={props.page.navigation.header}
            footer={props.page.navigation.footer}
            unlinked={props.page.navigation.unlinked}
            productCategories={props.page.navigation.productCategories}
            actionLookup={props.page.navigation.actionLookup}
            schema={props.page.navigation.schema}
            theme={props.website.theme}
            blocks={props.page.components}
            popups={props.page.popUps}
            website={props.website}
        />
    );
};
